export const blockIconsHardwareKeyboard = (
	<span className='material-symbols-outlined'>keyboard</span>
);
